<template>
  <div class="openClass">
    <headers
      class="herderNav"
      ref="header"
      :isChange="true"
    />
    <el-carousel height="100vh">
      <el-carousel-item
        v-for="(banner, indexer) in bannerList"
        :key="indexer"
      >
        <el-image
          style="width: 100p%; height: 100%"
          :src="base + banner"
          fit="cover"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="openClassCon">
      <div
        class="box"
        id="free"
      >
        <h1>免费公开课</h1>
        <!-- 公开课轮播 -->
        <div class="swiperCon new_card">
          <swiper
            :options="swiperOption1"
            :not-next-tick="notNextTick"
            ref="mySwiper"
          >
            <!-- slides -->
            <swiper-slide
              class="swiperSlide"
              v-for="(item, index) in openClassList[0]"
              :key="index"
              v-if="item !== 'fuck'"
            >
              <div class="newCard">
                <div class="newCard_top">
                  <p><img
                      src="@/assets/bottom/bottomIcon.png"
                      alt=""
                    /></p>
                  <p>{{ item.teacher_name }}</p>
                  <p class="techer-detail">{{ item.position }}</p>
                  <el-image
                    :src="base + item.img"
                    class="newCard_bg"
                  ></el-image>
                </div>
                <div class="newCard_bottom">
                  <p>{{ item.description }}</p>
                  <p>
                    <span class="newCard_time">{{ item.date }} {{ item.time }}</span>
                    <button
                      type="button"
                      @click="btnStatus(item.status, item.id, item.url, index)"
                    >
                      {{ item.status }}
                    </button>
                  </p>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-button-prev one"
              style="margin-top: 3px; margin-left: -15px; background: none"
              slot="button-prev"
            >
              <img
                src="@/assets/home/leftIcon.png"
                alt=""
                class="btnImg"
              />
            </div>
            <div
              class="swiper-button-next one"
              style="margin-top: 3px; margin-right: -35px; background: none"
              slot="button-next"
            >
              <img
                src="@/assets/home/rightIcon.png"
                alt=""
                class="btnImg"
              />
            </div>
          </swiper>
        </div>
      </div>
      <div
        class="box"
        id="newest"
      >
        <h1>最新刷题班</h1>
        <div class="swiperCon">
          <swiper
            :options="swiperOption"
            :not-next-tick="notNextTick"
            ref="mySwiper"
          >
            <swiper-slide
              class="signUpSwiper"
              v-for="(ele, indexs) in freeList"
              :key="indexs"
              v-if="ele !== 'free'"
            >
              <div class="new">
                <div
                  class="top"
                  style="position: relative"
                >
                  <img
                    :src="base + ele.img"
                    alt=""
                    style="
                      position: absolute;
                      left: 0;
                      padding: 0;
                      width: 100%;
                      height: 100%;
                      border-radius: 7px 7px 0 0;
                    "
                  />
                  <el-image
                    :src="base + ele.avatar_url"
                    style="
                      z-index: 99;
                      width: 100px;
                      height: 100px;
                      border-radius: 50%;
                    "
                    fit="cover"
                  ></el-image>
                </div>
                <div class="tit">{{ ele.title }}</div>
                <div class="job">{{ ele.description }}</div>
                <div class="name">{{ ele.teacher_name }}</div>
                <div class="time">{{ ele.date }}到{{ ele.end_time }}</div>
                <div
                  class="btn"
                  @click="freeDom(ele.status, ele.id, ele.url, indexs)"
                >
                  {{ ele.status
                  }}<i class="el-icon-view el-icon-arrow-right"></i>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-button-prev"
              style="margin-top: 3px; margin-left: -25px; background: none"
              slot="button-prev"
            >
              <img
                src="@/assets/home/leftIcon.png"
                alt=""
                class="btnImg"
              />
            </div>
            <div
              class="swiper-button-next"
              style="margin-top: 3px; margin-right: -35px; background: none"
              slot="button-next"
            >
              <img
                src="@/assets/home/rightIcon.png"
                alt=""
                class="btnImg"
              />
            </div>
          </swiper>
        </div>
        <a
          href="#free"
          id="a1"
          v-show="false"
        >box1</a>
        <a
          href="#newest"
          id="a2"
          v-show="false"
        >box2</a>
      </div>
      <!-- 训练营 -->
    </div>
  </div>
</template>
<script>
import api from "@/api/activeTest.js";
import banner from "@/api/home.js";
import baseUrl from "@/api/common.js";
import headers from "@/components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      //Banner
      bannerList: [],
      notNextTick: true,
      //公开课
      openClassList: [],
      //免费课
      freeList: [],
      swiperOption: {
        autoplay: false,
        loop: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 4,
      },
      swiperOption1: {
        autoplay: false,
        grabCursor: true,
        loop: false,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 4,
      },
      typeOf: "",
      typeMethods: "",
      base: baseUrl,
    };
  },
  methods: {
    setScrollTop(top) {
      if (!isNaN(top)) document.body.scrollTop = top;
    },
    //Banner
    getBanner() {
      let paramss = {
        type: "activity",
      };
      let querys = this.$qs.stringify(paramss);
      banner
        .getBannerList(querys)
        .then((res) => {
          this.bannerList = res.data.data;
        })
        .catch((err) => {
          this.$message.error("Banner错误");
        });
    },
    //公开课
    btnStatus(status, ids, url, index) {
      this.typeOf = "open";
      if (status === "立即预约") {
        this.typeMethods = "open";
        sessionStorage.setItem(
          "openClassList",
          JSON.stringify(this.openClassList[0])
        );
        this.$router.push(`/subscribe/${ids}/${this.typeMethods}/${index}`);
      }
      if (status === "已预约") {
        if (url) {
          window.location.href = url;
        }
      }
    },
    //免费训练营
    freeDom(status, ids, url, index) {
      this.typeOf = "free";
      if (status == "马上报名") {
        this.typeMethods = "free";
        sessionStorage.setItem("freeList", JSON.stringify(this.freeList));
        this.$router.push(`/subscribe/${ids}/${this.typeMethods}/${index}`);
      }
      if (status == "已预约") {
        if (url) {
          window.location.href = url;
        }
      }
    },
    //最新公开课 免费课
    getClass() {
      let now = new Date();
      let month = parseInt((now.getMonth() + 1).toString().padStart(2, 0));
      let day = parseInt(now.getDate().toString().padStart(2, 0));
      let hour = parseInt(now.getHours().toString().padStart(2, 0));
      let minute = parseInt(now.getMinutes().toString().padStart(2, 0));
      // console.log(month, day, hour, minute);
      // 过期不显示
      api
        .getOpenClass()
        .then((res) => {
          // 排序 免费公开课在右边
          let open = res.data.data;

          function compare(t) {
            return function (a, b) {
              var at = a[t];
              var bt = b[t];
              return at - bt;
            };
          }
          open[0].sort(compare("dates"));
          this.openClassList = open;
          // console.log(this.openClassList,'公开课');
          this.openClassList[0].forEach((item, index) => {
            // //console.log(item.date);
            let openMonth = parseInt(item.date.split("-")[0]);
            let openDay = parseInt(item.date.split("-")[1]);
            let openHour = parseInt(
              $.trim(item.time.split("-")[1]).split(":")[0]
            );
            let openMinute = parseInt(
              $.trim(item.time.split("-")[1]).split(":")[1]
            );
            // console.log(openMonth,openDay,openHour,openMinute,'结束时间')
            if (month > openMonth) {
              //console.log('fuck',index);
              this.openClassList[0].splice(index, 1, "fuck");
            } else if (month == openMonth) {
              if (day > openDay) {
                //console.log('fuck',index)
                this.openClassList[0].splice(index, 1, "fuck");
              } else if (day == openDay) {
                if (hour > openHour) {
                  //console.log('fuck',index)
                  this.openClassList[0].splice(index, 1, "fuck");
                } else if (hour == openHour) {
                  if (minute > openMinute) {
                    //console.log('fuck',index)
                    this.openClassList[0].splice(index, 1, "fuck");
                    // console.log(this.openClassList[0]);
                  } else {
                    //console.log('shit',index);
                  }
                } else {
                }
              } else {
              }
            } else {
            }
          });
        })
        .catch((err) => {
          this.$message.error("数据获取失败");
        });
      api
        .freeClass()
        .then((res) => {
          // 排序 最新课程在右边
          let free = res.data.data;

          function compare(t) {
            return function (a, b) {
              var at = a[t];
              var bt = b[t];
              return at - bt;
            };
          }
          free.sort(compare("dates"));
          this.freeList = free;
          // console.log(this.freeList,'最新刷题班')
          this.freeList.forEach((item, index) => {
            let freeMonth = parseInt(item.end_time.split("-")[0]);
            let freeDay = parseInt(item.end_time.split("-")[1]);
            let freeHour = parseInt(
              $.trim(item.time.split("-")[1]).split(":")[0]
            );
            let freeMinute = parseInt(
              $.trim(item.time.split("-")[1]).split(":")[1]
            );
            console.log(freeMonth, freeDay, freeHour, freeMinute);
            if (month > freeMonth) {
              //console.log('free',index)
              this.freeList.splice(index, 1, "free");
            } else if (month == freeMonth) {
              if (day > freeDay) {
                //console.log('free',index)
                this.freeList.splice(index, 1, "free");
              } else if (day == freeDay) {
                if (hour > freeHour) {
                  //console.log('free',index)
                  this.freeList.splice(index, 1, "free");
                } else if (hour == freeHour) {
                  if (minute > freeMinute) {
                    //console.log('free',index)
                    // console.log(minute,freeMinute,'ss')
                    this.freeList.splice(index, 1, "free");
                  } else {
                    //console.log('shit',index);
                  }
                } else {
                }
              } else {
              }
            } else {
            }
          });
        })
        .catch((err) => {
          this.$message.error("数据获取失败");
        });
    },
    checkTime() {},
    handleScrollx() {
      let header = this.$refs.header;
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop == 0) {
        header.headerBack.background = "";
        header.herderTits.color = "hsla(0,0%,100%,.8)";
        header.headerIcon = require("@/assets/bottom/bottomIcon.png");
        header.loginButton = {
          backgroundColor: "white",
          color: " rgba(0,0,0,.8)",
        };
        header.isTop = true;

        header.phoneButton = {
          background: "hsla(0,0%,100%,.08)",
          border: "1px solid hsla(0,0%,100%,.8)",
        };
        // this.navCodes = require('@/assets/login/whiteCode.png');
      } else {
        header.isTop = false;
        header.headerBack.background = "#ffffff";
        header.herderTits.color = "#666666";
        header.headerIcon = require("@/assets/home/headerNav.png");
        header.loginButton = {
          background: "#618aff",
          color: "#fff",
        };
        header.phoneButton = {
          color: "#618aff",
          border: "1px solid #618aff",
        };
        // this.navCodes = require('@/assets/login/navCode.png');
      }
      if (scrollTop > 723) {
        this.rightDiv = true;
      } else {
        this.rightDiv = false;
      }
    },
  },
  mounted() {
    this.checkTime();
    if (this.$route.params.skip === "free") {
      a1.click();
    } else if (this.$route.params.skip === "newest") {
      a2.click();
    }
    this.$router.afterEach((to, from, next) => {
      console.log(to, from);
      if (to.path === "/free") {
        this.$router.push("/openClass/free");
      } else if (to.path === "/newest") {
        this.$router.push("/openClass/newest");
      }
      // //console.log(to.params.skip);
      if (to.params.skip === "free") {
        a1.click();
      } else if (to.params.skip === "newest") {
        a2.click();
      }
    });
    window.addEventListener("scroll", this.handleScrollx);
    this.getClass();
    setInterval(() => {
      this.getClass();
    }, 50000);
    this.getBanner();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  beforeDestroy() {
    // //console.log('销毁');
    window.removeEventListener("scroll", this.handleScrollx);
  },
};
</script>

<style scoped>
@import "../../assets/css/openClass.css";
</style>



// WEBPACK FOOTER //
// src/view/teacherTeam/openClass.vue